import React from 'react';
const pains = ['Uso los óvulos, me pasa por 3 días y en una semana vuelve todo igual', "El ginecólogo me dice que soy 'propensa' y me receta lo mismo de siempre", 'Gasté más de $200.000 este año en consultas y tratamientos que no funcionan', 'Evito las relaciones porque tengo miedo al dolor o a que mi pareja lo note', 'Me hincho como si estuviera embarazada al final del día y no entiendo por qué'];
export function PainSection() {
  return <section className="w-full bg-brand-violet px-6 py-16" data-id="element-171">
      <div className="max-w-2xl mx-auto" data-id="element-172">
        <h2 className="text-[28px] font-bold text-white text-center mb-2 leading-tight" data-id="element-173">
          ESTO TE ESTÁ PASANDO A VOS
        </h2>
        <p className="text-white/80 text-center text-[16px] mb-10" data-id="element-174">
          ¿Cuántas de estas frases te suenan?
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-10" data-id="element-175">
          {pains.map((pain, i) => <div key={i} className="bg-white/10 rounded-[16px] p-5 flex items-start gap-3 border border-white/5 shadow-[0_4px_24px_rgba(0,0,0,0.08)]" data-id="element-176">
              <span className="text-lg flex-shrink-0 mt-0.5" data-id="element-177">🔴</span>
              <p className="text-[15px] text-white leading-relaxed font-medium" data-id="element-178">
                "{pain}"
              </p>
            </div>)}
        </div>

        <p className="text-[15px] text-white/90 leading-relaxed text-center italic max-w-xl mx-auto" data-id="element-179">
          Si marcaste aunque sea 2 de estas frases, no es tu culpa. No es falta
          de higiene. Es un mecanismo biológico específico que ningún turno de
          10 minutos tiene tiempo de explicarte.
        </p>
      </div>
    </section>;
}